module.exports = __webpack_public_path__ + "static/media/bg_2.d908b69b.jpg";